import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initializeAnalytics } from "./lib/analytics";
import { loadConfig, applyTheme, type AppConfig } from "./lib/config";
import "./styles/index.scss";

function render(config: AppConfig) {
  const root = createRoot(document.getElementById("root")!);
  root.render(
    <StrictMode>
      <App config={config} />
    </StrictMode>,
  );
}

// Built-in fallback so the app can still mount if /api/config fails.
const FALLBACK_CONFIG: AppConfig = {
  brand_name: "Calltree",
  logo_url: null,
  theme: {
    primary_color: "#6366f1",
    secondary_color: "#8b5cf6",
    font_family: "system-ui, sans-serif",
  },
  features: {},
  analytics: { posthog: { public_api_key: "" } },
  rum: { application_id: "", region: "us-east-1" },
};

// Bootstrap: load config, apply theme, init analytics, then render
loadConfig()
  .then((config) => {
    applyTheme(config);
    initializeAnalytics(config);
    render(config);
  })
  .catch((err) => {
    console.warn("[Bootstrap] Failed to load config:", err);
    render(FALLBACK_CONFIG);
  });
